import type {
  DesktopHostInfo,
  DesktopTriggerKey,
} from "@/clients/desktop.client";

type TranslateTriggerLabel = (
  key: string,
  options: { defaultValue: string },
) => string;

export const desktopTriggerLabel = (
  key: DesktopTriggerKey,
  platform: DesktopHostInfo["platform"] | undefined,
  translate: TranslateTriggerLabel,
): string => {
  const label = (name: string, defaultValue: string) =>
    translate(`desktopDictation.triggerKeys.${name}`, { defaultValue });

  switch (key) {
    case "AltRight":
      return platform === "macos"
        ? label("rightOption", "Right Option")
        : label("rightAlt", "Right Alt / AltGr");
    case "AltLeft":
      return platform === "macos"
        ? label("leftOption", "Left Option")
        : label("leftAlt", "Left Alt");
    case "ControlRight":
      return platform === "macos"
        ? label("rightControl", "Right Control")
        : label("rightCtrl", "Right Ctrl");
    case "ShiftRight":
      return label("rightShift", "Right Shift");
    case "MetaRight":
      return platform === "macos"
        ? label("rightCommand", "Right Command")
        : label("rightWindows", "Right Windows");
  }

  return key;
};

export const desktopTriggerKeycap = (
  key: DesktopTriggerKey,
  platform: DesktopHostInfo["platform"] | undefined,
): string => {
  if (key === "ShiftRight") return "⇧";
  if (key === "ControlRight") return platform === "macos" ? "⌃" : "Ctrl";
  if (key === "MetaRight") return platform === "macos" ? "⌘" : "Win";
  return platform === "macos" ? "⌥" : "Alt";
};
